import loadable from "@loadable/component";

export const DeliverySettingsList = loadable(() => import("./list"));
